import React from 'react'
import { GridHeader, GridRow } from 'src/components/Reusable/Grid'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { IsGatekeeperEnabled, GatekeeperFlag } from 'src/context/Gatekeeper'
import { getControlsListItemConfig } from '../../IndexItem/ControlsListItem.helpers'
import { ControlListItemConfig } from '../../IndexItem/ControlListItem.constants'
import { ControlsGridHeader } from './ControlsIndexGrid.styles'
import {
  ControlsIndexGridOwnerHeader,
  ControlsIndexGridOperatingEffectivenessHeader,
  ControlsIndexGridDepartmentHeader,
  ControlsIndexGridFrameworksHeader,
  ControlsIndexGridIdHeader,
  ControlsIndexGridLinkedEvidenceHeader,
  ControlsIndexGridNameHeader,
  ControlsIndexGridStatusHeader,
  ControlsIndexGridCPMDHeader,
  ControlsIndexGridLabelsHeader,
} from './ControlsIndexGrid.components'

export const ControlsIndexGridHeader = ({
  config,
  showContentMatchColumn,
}: {
  config?: ControlListItemConfig
  showContentMatchColumn?: boolean
}): JSX.Element => {
  const canViewAuditScans = useCanPerformAction(CAPABILITY.CAN_VIEW_AUDIT_SCANS)
  const {
    showDepartmentColumn,
    showModelIdColumn,
    showControlNameColumn,
    showFrameworkColumn,
    showOperatingEffectivenessColumn,
    showCPMDColumn,
    showLinkedEvidenceColumn,
    showStatusColumn,
    showOwnerColumn,
    showMenuColumn,
  } = getControlsListItemConfig(config)

  const showLabels = IsGatekeeperEnabled(GatekeeperFlag.LABELS)

  const showOperatingEffectiveness =
    canViewAuditScans && showOperatingEffectivenessColumn

  const showCPMD = canViewAuditScans && showCPMDColumn

  return (
    <GridRow>
      {showContentMatchColumn && <GridHeader />}
      {showDepartmentColumn && <ControlsIndexGridDepartmentHeader />}
      {showModelIdColumn && <ControlsIndexGridIdHeader />}
      {showControlNameColumn && <ControlsIndexGridNameHeader />}
      {showLabels && <ControlsIndexGridLabelsHeader />}
      {showFrameworkColumn && <ControlsIndexGridFrameworksHeader />}
      {showLinkedEvidenceColumn && <ControlsIndexGridLinkedEvidenceHeader />}
      {showCPMD && <ControlsIndexGridCPMDHeader />}
      {showOperatingEffectiveness && (
        <ControlsIndexGridOperatingEffectivenessHeader />
      )}
      {showStatusColumn && <ControlsIndexGridStatusHeader />}
      {showOwnerColumn && <ControlsIndexGridOwnerHeader />}
      {showOwnerColumn && (
        <ControlsGridHeader justifyContent="flex-start">
          Assignees
        </ControlsGridHeader>
      )}
      {showMenuColumn && <ControlsGridHeader />}
    </GridRow>
  )
}
